import { LinkedAccount } from "../../../../../models/Entities";
import React from "react";
import MetadataPair from "./MetadataPair";
import { CopyTextField, Text } from "@merge-api/merge-javascript-shared";
import { displayNameForAPICategoryIntegration } from "../../../../../models/Helpers";
import { DATE_FORMAT } from "../../../../../constants";

export interface Props {
  /**
   * The account to display info for if it exists
   */
  linkedAccount?: LinkedAccount;
}

const APIExplorerMetadata = ({ linkedAccount }: Props) => {
  // Integration
  const integration = linkedAccount ? (
    linkedAccount.integration && linkedAccount.category ? (
      <MetadataPair
        label="Integration"
        data={
          <div className="flex flex-row gap-x-2">
            <Text>{linkedAccount.integration.name}</Text> -
            <Text>{displayNameForAPICategoryIntegration(linkedAccount.category)}</Text>
          </div>
        }
      />
    ) : null
  ) : (
    <MetadataPair label="Integration" data="—" />
  );

  // Linked date
  const linkedDate = linkedAccount ? (
    linkedAccount.completed_at ? (
      <MetadataPair
        label="Linked"
        data={new Date(linkedAccount.completed_at).toLocaleDateString(undefined, DATE_FORMAT)}
      />
    ) : null
  ) : (
    <MetadataPair label="Linked" data="—" />
  );

  // Account token
  const accountToken = (
    <MetadataPair
      label="Account token"
      labelHoverText="Use account tokens to interact with Merge's API"
      data={
        // Account token is a secret and is thus masked at the field (ph-no-capture for PostHog, data-fr-ignore for the Frigade Assistant DOM snapshot)
        <div className="ph-no-capture w-full" data-fr-ignore>
          <CopyTextField
            className="w-full border border-gray-10"
            text={
              linkedAccount?.account_token
                ? linkedAccount.account_token
                : "SAMPLE TEST LINKED ACCOUNT TOKEN"
            }
            secret
          />
        </div>
      }
    />
  );

  return (
    <div className="flex flex-col gap-3">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        {integration}
        {linkedDate}
      </div>
      {accountToken}
    </div>
  );
};

export default APIExplorerMetadata;
